import React from 'react';
import { Box } from '@mui/material';
import Config from '../../lib/Config';
import '../../assets/style/fonts.css';
// import { useNavigate } from 'react-router-dom';


export default (props) => {

   // const navigate = useNavigate();

    return (
            <Box sx={{ fontFamily: 'Quicksand', fontSize: '16px',fontWeight:'normal',  cursor:'pointer', color:'#222222' }} onClick={()=>{/*navigate(Config.BASE_URL);*/}} >&nbsp;&nbsp;AngelTrip</Box>
    );

}